export default "__VITE_ASSET__CSsQ5VP1__"